const UrlApi = {
  // local
  // baseUrl: "http://localhost:4000/users/",
  // baseUrlImage: "http://localhost:4000/uploads/",

  //office
  baseUrl: "https://api.sagio.me/users/",
  baseUrlImage: "https://api.sagio.me/uploads/",

  //
  // baseUrl: "http://192.168.0.28:4000/users/",
  // baseUrlImage: "http://192.168.0.28:4000/uploads/",

  what_we_do: {
    get: "what_we_do",
  },

  clients: {
    get: "clients",
  },

  services: {
    get: "services",
  },
  service: {
    get: "service",
  },

  services_info: {
    get: "services_info",
  },

  testimonials: {
    get: "testimonials",
  },

  settings: {
    get: "settings",
  },

  about_us: {
    get: "about_us",
  },

  blog: {
    get: "blog",
  },

  projects: {
    get: "projects",
  },

  blog_info: {
    get: "selected_blog",
  },

  selected_service: {
    get: "selected_service",
  },

  projects_info: {
    get: 'selected_project',
  },
  case_study: {
    get: 'case_study',
  },

  case_study_info: {
    get: "selected_case_study",
  },

};

export default UrlApi;
